/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Betragfix (Betrag fix)
 * 
 * 401130001 = Betragwahlbar (Betrag wählbar)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceMittelabrufzahlung {
 Betragfix = 401130000,
 Betragwahlbar = 401130001
}

marker([
    "Enum.GlobalEnumsAceMittelabrufzahlung.Betragfix",
    "Enum.GlobalEnumsAceMittelabrufzahlung.Betragwahlbar"
]);

export namespace GlobalEnumsAceMittelabrufzahlung
{
    class DataSets
    {
        static GlobalEnumsAceMittelabrufzahlungDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Betragfix", 401130000, "Betrag fix"),
            new EnumValue("Betragwahlbar", 401130001, "Betrag wählbar"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceMittelabrufzahlungDataSet;
    }
}
